import { useEffect, useState, useRef } from "react";
import { Form } from "react-bootstrap";
import { Pagination, Button } from "react-bootstrap";
import Select from "react-select";
import { useLocation } from "react-router-dom";
import { developAxios } from "../axios.config";
import { useQuery } from "react-query";
import {
	NotificationContainer,
	NotificationManager,
} from "react-notifications";
import "react-notifications/lib/notifications.css";
let examTypes = [
	{ value: "Test", label: "Test" },
	{
		value: "assignment",
		label: "Assignment",
	},
];

let languageValues = [
	{ value: "", label: "Select Language" },
	{ value: "Quant", label: "Quant" },
	{ value: "Verbal", label: "Verbal" },
	{ value: "DI/LR", label: "DI/LR" },
];

const QuizExamCreating = () => {
	const [questionsArray, setquestionsArray] = useState([]);
	const [nameoftheexam, setnameoftheexam] = useState("");
	const [timeoftheexam, settimeoftheexam] = useState("");
	const [courses, setCourses] = useState([]);
	const [course, setcourse] = useState([]);
	const [category, setCategory] = useState("");
	const [company, setCompany] = useState("");
	const [description, setDescription] = useState("");
	const [attempts, setattempts] = useState("");
	const [typeOfExam, settypeOfExam] = useState("");
	const [genre, setGenre] = useState("");
	const [currPage, setCurrPage] = useState(0);
	const [type, setype] = useState("");
	const [language, setlanguage] = useState({
		value: "",
		label: "Select Language",
	});
	const [subtopic, setsubtopic] = useState("");
	const [topic, settopic] = useState("");
	const [locked, setLocked] = useState(false);
	const [displayResult, setDisplayResult] = useState(true);
	const [shuffleQuestions, setShuffleQuestions] = useState(true);
	const [examDate, setExamDate] = useState(Date.now());
	const [examEndTime, setExamEndTime] = useState(
		examDate + 365 * 24 * 60 * 60 * 1000
	);
	const searchRef = useRef("");
	const location = useLocation();
	const formatDateForInput = (timestamp) => {
		const date = new Date(timestamp);
		const isoString = date.toISOString().slice(0, 16);
		return isoString;
	};
	const parseInputToDate = (inputValue) => {
		const [datePart, timePart] = inputValue.split("T");
		const [year, month, day] = datePart.split("-");
		const [hour, minute] = timePart.split(":");
		const date = new Date(year, month - 1, day, hour, minute);
		return date.getTime();
	};
	useEffect(() => {
		developAxios(localStorage.getItem("token"))
			.get("/getallCourse")
			.then(({ data }) => {
				let temp = [];

				for (let i = 0; i < data.courses.length; i++) {
					temp.push({
						value: data.courses[i]._id,
						label: data.courses[i].name,
					});
				}
				setCourses(temp);
			})
			.catch((err) => {
				console.log(err.response);
			});

		if (!location.state) return;

		const {
			category,
			company,
			timer,
			description,
			questions,
			examName,
			attempts,
			typeOfExam,
			genre,
			language,
			type,
			topic,
			Subtopic,
			locked,
			displayResult,
			shuffleQuestions,
		} = location.state;

		if (category) setCategory(category);
		if (company) setCompany(company);
		if (timer) settimeoftheexam(timer);
		if (description) setDescription(description);
		if (questions) setquestionsArray(questions);
		if (examName) setnameoftheexam(examName);
		if (attempts) setattempts(attempts);
		if (typeOfExam) settypeOfExam({ value: typeOfExam, label: typeOfExam });
		if (genre) setGenre(genre);
		if (language) {
			if (language === "") {
				setlanguage({ value: "", label: "Select Language" });
			} else {
				setlanguage({ value: language, label: language });
			}
		}
		if (type) setype(type);
		if (topic) settopic(topic);
		if (Subtopic) setsubtopic(Subtopic);
		setLocked(!!locked);
		setDisplayResult(!!displayResult);
		setShuffleQuestions(!!shuffleQuestions);
	}, [location]);

	const {
		data: Questions,
		isLoading: questionsLoading,
		isError: questionsError,
		refetch: questionsRefetch,
	} = useQuery(
		["get-question-schema", currPage],
		() => {
			return developAxios(localStorage.getItem("token")).get(
				"/getQuestionSchema",
				{
					params: {
						page: currPage,
						limit: 30,
						filter: !searchRef.current
							? ""
							: searchRef.current.value,
					},
				}
			);
		},
		{
			enabled: currPage === 0 ? true : !!currPage,
			initialData: {
				data: {
					data: [],
				},
			},
		}
	);

	function createNotification() {
		if (course.length === 0) {
			NotificationManager.info("Select atleast one course");
			return;
		}
		const data_exam = course.map(({ value }) => {
			return {
				category,
				company,
				timer: timeoftheexam,
				description,
				courseId: value,
				questions: questionsArray,
				examName: nameoftheexam,
				attempts,
				typeOfExam: typeOfExam.value,
				genre,
				language: language.value,
				type: type,
				topic: topic,
				Subtopic: subtopic,
				locked: locked,
				displayResult: displayResult,
				shuffleQuestions: shuffleQuestions,
				examDate: examDate,
				examEndTime: examEndTime,
				outOfScore: questionsArray.length,
			};
		});

		developAxios(localStorage.getItem("token"))
			.post("/createQuizExam", {
				exams: data_exam,
			})
			.then(({ data, res }) => {
				NotificationManager.success(
					"Created",
					" You have successfully created quiz "
				);
			})
			.catch((e) =>
				NotificationManager.error(
					`${e} error`,
					"Something Went wrong Please check again"
				)
			);
	}

	function AddValueinArray(name) {
		setquestionsArray((prev) => {
			if (prev.includes(name)) {
				let temp_arr = prev.filter((value) => value !== name);
				return [...temp_arr];
			} else {
				return [...prev, name];
			}
		});
	}

	function CheckExistorNot(name, questionArray) {
		for (var singlevalue of questionArray) {
			if (singlevalue === name) {
				return true;
			}
		}
		return false;
	}

	const handleSearch = () => {
		setCurrPage(0);

		questionsRefetch();
	};

	return (
		<>
			<NotificationContainer />
			<div className="text-center mt-3">
				<p>Name of the exam</p>
				<input
					type="text"
					value={nameoftheexam}
					onChange={(e) => setnameoftheexam(e.target.value)}
					className="form-control mx-auto w-50"
					placeholder="Enter the name of the exam"
				/>
				<br />
				<p>Enter the Description of the test</p>
				<input
					type="text"
					className="form-control mx-auto w-50"
					value={description}
					onChange={(e) => setDescription(e.target.value)}
					placeholder="Enter Description"
				/>
				<br />
				<p>Enter the time for the exam</p>
				<input
					type="text"
					className="form-control mx-auto w-50"
					value={timeoftheexam}
					onChange={(e) => settimeoftheexam(e.target.value)}
					placeholder="Enter the Time of the exam"
				/>
				<br />
				<p>Enter the Company for test.</p>
				<input
					type="text"
					className="form-control mx-auto w-50"
					value={company}
					onChange={(e) => setCompany(e.target.value)}
					placeholder="Enter Company Name"
				/>
				<br />
				<p>Enter Category.</p>
				<input
					type="text"
					className="form-control mx-auto w-50"
					value={category}
					onChange={(e) => setCategory(e.target.value)}
					placeholder="Enter Category Name"
				/>
				<br />
				<p>Enter No. of Attempts user will get</p>
				<input
					type="number"
					className="form-control mx-auto w-50"
					value={attempts}
					onChange={(e) => setattempts(e.target.value)}
					placeholder="Enter No. of Attempts"
				/>
				<br />
				<label htmlFor="Coursename">
					Choose the course for the exam
				</label>
				<Select
					isMulti
					name="Coursename"
					options={courses}
					className="basic-multi-select w-50 m-[auto]"
					classNamePrefix="select"
					onChange={(values) => setcourse(values)}
					value={course}
				/>
				<br />
				<p>Select the type of the exam</p>
				<div>
					<Select
						name="examType"
						options={examTypes}
						style={{ marginLeft: "3px" }}
						className="basic-multi-select text-center w-50 row justify-content-center"
						classNamePrefix="select"
						value={typeOfExam}
						onChange={(val) => settypeOfExam(val)}
					/>{" "}
				</div>
				<br></br>
				<p>Enter Genre.</p>
				<div>
					<Select
						name="language"
						options={languageValues}
						style={{ marginLeft: "3px" }}
						className="basic-multi-select text-center w-50 row justify-content-center"
						classNamePrefix="select"
						value={language}
						onChange={(val) => setlanguage(val)}
					/>{" "}
				</div>
				<br></br>
				<select
					className={`form-control mx-auto w-50`}
					aria-label="Default select example"
					value={type}
					onChange={(e) => {
						setype(e.target.value);
					}}
				>
					<br></br>
					<option value="">Select the type of the exam</option>
					<option value="Technical Exam">Technical Exam</option>
					<option value="Aptitude Exam">Aptitude Exam</option>
				</select>
				<br />
				<p>Start Date</p>
				<input
					type="datetime-local"
					className="form-control mx-auto w-50"
					name="examDate"
					value={formatDateForInput(examDate)}
					onChange={(e) => {
						setExamDate(parseInputToDate(e.target.value));
					}}
					placeholder="Start Date"
				/>
				<br />
				<p>End Date</p>
				<input
					type="datetime-local"
					className="form-control mx-auto w-50"
					name="examEndTime"
					value={formatDateForInput(examEndTime)}
					onChange={(e) => {
						setExamEndTime(parseInputToDate(e.target.value));
					}}
					placeholder="Start Date"
				/>
				<br />
				<div className="d-flex justify-content-center">
					<Form.Check
						type="switch"
						label="Locked"
						checked={locked}
						onChange={(e) => setLocked((val) => !val)}
					/>
				</div>
				<br />
				<div className="d-flex justify-content-center">
					<Form.Check
						type="switch"
						label="Display Result"
						checked={displayResult}
						onChange={(e) => setDisplayResult((val) => !val)}
					/>
				</div>
				<br />
				<div className="d-flex justify-content-center">
					<Form.Check
						type="switch"
						label="Shuffle Questions"
						checked={shuffleQuestions}
						onChange={(e) => setShuffleQuestions((val) => !val)}
					/>
				</div>
				<br></br>
				<button
					style={{ marginTop: "22px" }}
					onClick={() =>
						createNotification("sucess", "error", "info")
					}
					className="btn btn-success btn-lg mx-auto"
				>
					Create The exam
				</button>
				<br></br>
				<div className>
					<br></br>
					Questions Added = {questionsArray.length}
					<br />
					<div className=" ">
						<p> Select the questions for the exam </p>

						<div>
							<div>
								<label htmlFor="search">
									Search by Topic:
									<div className="d-flex">
										<input
											id="search"
											type="text"
											ref={searchRef}
											placeholder="Search by topic"
										/>
										<Button
											style={{ color: "black" }}
											variant="success"
											onClick={handleSearch}
										>
											Search
										</Button>
									</div>
								</label>
							</div>
							<br />

							<table
								data-toggle="table"
								class="table table-hover"
							>
								<thead class="thead-dark">
									<tr>
										<th class="text-dark ">S.No</th>

										<th class="text-dark text-right">
											Questions
										</th>
										<th class="text-dark text-right">
											Topic
										</th>
									</tr>
								</thead>
								<tbody>
									{!questionsLoading &&
										!questionsError &&
										Questions.data.data.map(
											(value, index) => (
												<tr
													key={value._id}
													style={{
														background:
															questionsArray.includes(
																value._id
															)
																? "#000"
																: undefined,
														textAlign: "left",
														color:
															CheckExistorNot(
																value._id,
																questionsArray
															) && "#fff",
													}}
													onClick={() => {
														AddValueinArray(
															value._id
														);
													}}
												>
													<td>
														{30 * currPage +
															index +
															1}
													</td>
													<td>{value.question}</td>
													<td>{value.topic}</td>
												</tr>
											)
										)}
								</tbody>
							</table>
							<Pagination
								style={{
									justifyContent: "center",
								}}
							>
								{currPage !== 0 && (
									<Pagination.Prev
										onClick={() =>
											setCurrPage((prev) => --prev)
										}
									/>
								)}
								<Pagination.Item active={true}>
									{currPage + 1}
								</Pagination.Item>
								<Pagination.Next
									onClick={() =>
										setCurrPage((prev) => ++prev)
									}
								/>
							</Pagination>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default QuizExamCreating;
